const getEn = (number) => {
    if (!number) {
        return "";
    }
    var res = number
        .replace(/[\u0660-\u0669]/g, function (c) {
            return c.charCodeAt(0) - 0x0660;
        })
        .replace(/[\u06f0-\u06f9]/g, function (c) {
            return c.charCodeAt(0) - 0x06f0;
        });
    return res;
};

const formatNumber = (value) => {
    value = new String(value).replace(/,/g, "");
    return new String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const getFixedNumber = (num, fixed = 2) => {
    if (String(num).includes(",")) {
        num = num.replace(/,/g, "");
        num = parseFloat(num);
    }
    if (fixed === 0) {
        return num.toFixed(0);
    }
    if (Math.floor(num) === num) return num;
    return num.toFixed(fixed);
};

const getDateFormat = (date) => {
    if (date == null) {
        return null;
    }
    return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    );
};

export {
    getEn,
    formatNumber,
    getFixedNumber,
    getDateFormat
};